import { render, staticRenderFns } from "./ModelPlayground.vue?vue&type=template&id=cdf583b0"
import script from "./ModelPlayground.vue?vue&type=script&lang=js"
export * from "./ModelPlayground.vue?vue&type=script&lang=js"
import style0 from "./ModelPlayground.vue?vue&type=style&index=0&id=cdf583b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports